import { PfaDetails } from '../../create-request/models/overview/PfaDetails';
import { CashInfo } from './CashInfo';
import { Eauthorization } from './Eauthorization';
import { TaxInfo } from './TaxInfo';

export class AccountInfo {
  accountId: string;
  registrationType: string;
  categoryType: string;
  subAccountNameLine1: string;
  subAccountNameLine2: string;
  subAccountNameLine3: string;
  classifications: Classifications;
  eauthorization: Eauthorization;
  updated: string;
  acknowledgementText: string;
  formerTdaIndicator: boolean;
  overviewFailed?: boolean;
  accountInfoCallSuccess?: boolean;
  userName: string;
  isBtMasterOnly: boolean;
  primaryMaster: string;
  pfaDetails: PfaDetails;
}

export interface AccountInfoResponse extends AccountInfo {
  cashBalances: CashInfo;
  taxes: TaxInfo;
}

export class Classifications {
  isIra: boolean;
  isPtrs: boolean;
  isCustomer59OrOlder?: boolean;
  isRmdEligible?: boolean;
  isIip: boolean;
  isNraAccount?: boolean;
  isPreview?: boolean;
  isEmployee: boolean;
  isDbsUser: boolean;
  isDemoUser: boolean;
  isFsaUser: boolean;
  isTestamentaryTrust: boolean;
  isEstate: boolean;
  isGuardian: boolean;
  isConserv: boolean;
  hasBundledOffer: boolean;
}